/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  .alert {
    display: flex;
    width: 100%;
    gap: calc(var(--spacing, 0.25rem) * 3);
    border-radius: var(--radius-sm, 0.25rem);
    border-style: var(--tw-border-style);
    border-width: 1px;
    padding-inline: calc(var(--spacing, 0.25rem) * 4);
    padding-block: calc(var(--spacing, 0.25rem) * 3);
    font-size: var(--text-13, 0.8125rem);
    --tw-leading: calc(var(--spacing, 0.25rem) * 5);
    line-height: calc(var(--spacing, 0.25rem) * 5);
    color: var(--foundation-gray-800);
  }
  .info {
    border-color: var(--foundation-blue-300);
    background-color: var(--foundation-blue-100);
  }
  .warning {
    border-color: var(--foundation-orange-300);
    background-color: var(--foundation-orange-100);
  }
  .error {
    border-color: var(--foundation-red-300);
    background-color: var(--foundation-red-100);
  }
  .success {
    border-color: var(--foundation-green-300);
    background-color: var(--foundation-green-100);
  }
  .icon {
    flex-shrink: 0;
    font-size: var(--text-xl, 1.25rem);
    line-height: var(--leading-normal, 1.5);
    :where(.info) & {
      color: var(--foundation-blue-500);
    }
    :where(.warning) & {
      color: var(--foundation-orange-500);
    }
    :where(.error) & {
      color: var(--foundation-red-500);
    }
    :where(.success) & {
      color: var(--foundation-green-500);
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-leading: initial;
    }
  }
}
